(function () {
  function mainCode($) {
    var search_data;

    $(document).on('Searchanise.ResultsUpdated', function() {
        if ($('#snize-search-results-grid-mode').length && Searchanise.GetWidgets().searchResults.isMobileMode()) {
            $('#snize-search-results-grid-mode').attr('id', 'snize-search-results-list-mode');
            $(window).trigger('resize');
            $('a.snize-list-mode-icon').addClass('active');
        }
    });
  }
  function waitUntilDefined() {
    if (typeof Searchanise !== "undefined" && typeof Searchanise.$ !== "undefined") {
      mainCode(Searchanise.$);
    } else {
      setTimeout(waitUntilDefined, 400);
    }
  }
  waitUntilDefined();
})();